export default "__VITE_ASSET__D9$44qSJ__"